import React from 'react';
import '../../../components/General/Checkbox/style.scss';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Modal from '../../../components/General/PopupPrivacyPolicy';

import {
  MaxContainer,
  MaxWidth,
  Container,
  TitleBarBackground,
  TitleWidth,
  Title,
  Background,
  ContentBar,
  ArrowDiv,
  Arrow,
  FormBox,
} from './style';

const BusinessEnquiry = () => {
  const [Popupshow, setPopupShow] = React.useState(false);
  const { t } = useTranslation();

  return (
    <MaxContainer>
      <Container>
        <TitleBarBackground>
          <TitleWidth>
            <Title>{t('CsList.BUSINESS_ENQUIRY')}</Title>
          </TitleWidth>
        </TitleBarBackground>

        <Background>
          <ContentBar />
          <ArrowDiv>
            <Arrow />
          </ArrowDiv>
          <FormBox setPopupShow={setPopupShow} />
        </Background>
      </Container>
      <Modal onClose={() => setPopupShow(false)} Popupshow={Popupshow} />
    </MaxContainer>
  );
};

export default BusinessEnquiry;
